/**
 * Whether the viewer asked the system for reduced motion (`prefers-reduced-motion: reduce`). Falls back to
 * "no" where there is no `window.matchMedia` (vitest's node environment, very old browsers). Read when an
 * animation starts, not cached — the setting may change while the page is open. First used by the picker
 * gimmick (feature plan 0072); its tests mock this module.
 */
export function prefersReducedMotion(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
